<template>
	<div class="meeting-details max-content">
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item v-for="(item, key, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
						<img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="countDown" v-if="showTimeCountDown">
			<h4>距离会议开始 </h4>
			<van-count-down :time="time">
				<template #default="timeData">
					<span class="block">{{ timeData.days }}</span>
					<span class="colon">天</span>
					<span class="block">{{ timeData.hours }}</span>
					<span class="colon">时</span>
					<span class="block">{{ timeData.minutes }}</span>
					<span class="colon">分</span>
					<span class="block">{{ timeData.seconds }}</span>
					<span class="colon">秒</span>

				</template>
			</van-count-down>
		</div>
		<div class="buttons">
			<div class="row">
				<div class="one">
					<img src="./images/1.png" @click="skip(1818)" />
				</div>
				<div class="one">
					<img src="./images/3.png" @click="skip(1821)" />

				</div>
				<div class="one">
					<img src="./images/2.png" @click="skip(1817)" />

				</div>
				<div class="one">
					<img src="./images/4.png" @click="skip(1881)" />
				</div>
			</div>

			<div class="row">
				<div class="grid">
					<div class="half">
						<img src="./images/7.png" @click="skip(1819)" />
					</div>
					<div class="half column">
						<div class="cell">
							<img src="./images/10.png" @click="skip(1824)" />
						</div>
						<div class="cell">
							<img src="./images/11.png" @click="skip(1883)" />
						</div>
					</div>
				</div>
				<div class="grid">

					<div class="half">
						<img src="./images/5.png" @click="skip(1820)" />
					</div>
					<div class="half">
						<img src="./images/13.png" @click="skip(1823)" />
					</div>
					<div class="half">
						<img src="./images/9.png" @click="skip(1822)" />

					</div>
					<div class="half ">
						<img src="./images/6.png" @click="skip(1825)" />


					</div>

				</div>
			</div>
			<div style="display: flex;width: 100%;">
				<div class="half">
					<img src="./images/12.png" @click="skip(1880)" />
				</div>
				<div class="one">
					<img src="./images/18.png" @click="skip('history')" />
				</div>
				<div class="one">
					<img src="./images/17.png" @click="skip('visit')" />
				</div>
			</div>
		</div>
		<img class="bottom" src="@/assets/images/cvscf2023/bottom.png" style="width:100%" />
	</div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import { MeetingButtons, MeetingsCarousel, MeetingsDetails, companyImages } from '../../config/interface.js'
import { CountDown } from 'vant'
export default {
	components: {
		CountDown
	},
	data() {
		return {
			meetingButton: {},    //会议按钮
			swiperImg: [],
			meeting_id: '483',
			time: '',
			showTimeCountDown:false
		}
	},
	beforeRouteEnter(to, from, next) {
		//  修复iOS版微信HTML5 History兼容性问题
		if (to.path !== location.pathname) {

			location.assign(to.fullPath)
		} else {
			next()
		}
	},
	mounted() {
		this.getMeetingButtons(this.meeting_id);
		this.getMeetingCarousel();
		this.getMeetingDetails();
	},
	methods: {
		getImages() {
			const url = companyImages;
			let params = {
				meeting_id: this.meeting_id,
			}
			const method = "POST";
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.images = res.data;
					}
				})
		},
		//会议轮播
		getMeetingCarousel() {
			const url = MeetingsCarousel;
			let params = {
				meeting_id: this.meeting_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.swiperImg = data;
					}
				})
		},
		clickSwiperImg(item) {
			window.location.href = item.link;
		},
		//会议按钮
		getMeetingButtons(id) {
			const url = MeetingButtons;
			const method = 'POST';
			let params = {
				meeting_id: id
			};
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						this.meetingButton = data
						// console.log(this.meetingButton)
					}
				})
		},
		//会议详情
		getMeetingDetails() {
			const url = MeetingsDetails;
			const method = 'POST';
			let params = {
				meeting_id: this.meeting_id
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data = res.data;
						document.title = data.name;
						// this.meeting_dates=data.meeting_dates;
						this.time = this.countdownTo(data.start_at)
						if(this.time<=100){
							this.showTimeCountDown=false
						}else{
							this.showTimeCountDown=true

						}
						
						console.log(this.time)
						//微信浏览器  请求jsdk
						if (common.is_weixin()) {
							common.wxShare(data.name, data.title, data.shareimg);
						}
					}
				})
		},
		countdownTo(targetDateString) {
			// 将目标日期字符串转换为Date对象
			const targetDate = new Date(targetDateString);
			// 获取当前时间的Date对象
			const currentDate = new Date();
			// 计算时间差（以毫秒为单位）
			const differenceMs = targetDate.getTime() - currentDate.getTime();
			// 返回剩余时间（如果为负数，则表示目标日期已过）
			return differenceMs;
		},
		skip(id) {

			if (id == 1822) {
				this.$router.push({
					path: '/XVC/download',
					query: {
						button_id: id,
						meeting_id: this.meeting_id
					}
				})
			}
			// else if (id == 1881) {
			// 	this.$router.push({
			// 		path: '/XVC/hotel',
			// 		query: {
			// 			button_id: id
			// 		}
			// 	})
			// } 
			else if (id == 'history') {
				window.location.href = "https://c.xiumi.us/board/v5/5m32D/552421997"
				// this.$router.push({
				// 	path: '/XVC/history'
				// })
			} else if (id == 'visit') {
				window.location.href = "http://cdn.edstatic.com/203012120000/f9b1a5b17af5ec57af121309115b4ebc/2024/07/d8b49aaf-eff9-4e4c-b70a-b089d514665f.png"

			}

			else {
				for (var i = 0; i < this.meetingButton.length; i++) {
					if (this.meetingButton[i].id == id) {
						window.location.href = this.meetingButton[i].url;
					}

				}
				// window.location.href=this.meetingButton[id];
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.meeting-details {
	background: #f6f7f9;
	display: flex;
	flex-direction: column;

	.banner-show {
		width: 100%;
		padding: 0px;

		.cover {
			width: 100%;

			img {
				width: 100%;
			}
		}
	}

	.buttons {
		padding: 15px;
		flex: 1;

		.one {
			width: 25%;
			display: flex;
		}

		.two {
			width: 100%;
		}

		img {
			width: 94%;
			border-radius: 10px;
			display: block;
			margin: 0 auto 10px;
		}

		.row {
			width: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		.grid {
			width: 50%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;


		}

		.half {
			width: 50%;
			display: flex;
		}

		.cell {
			width: 100%;
		}

		.column {
			flex-direction: column;
		}
	}

}

.countDown {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2px 10px;
	width: fit-content;
	margin: 25px auto 15px;
	background-color: rgba(217, 37, 29, 1);
	border-radius: 8px;


	h4 {
		color: #fff;
		font-size: 12px;
		text-align: center;
		margin-right: 10px;
		font-weight: 500;
	}
}

.colon {
	display: inline-block;
	// margin: 0 4px;
	color: #ffffff;
	line-height: 30px;
	font-size: 12px;
	font-weight: 500;


}

.van-count-down {
	color: #fff;
}

.block {
	display: inline-block;
	color: #fff;
	font-size: 12px;
	text-align: center;
	border-radius: 5px;
	line-height: 20px;
	font-weight: 500;
	width: 28px;
	height: 20px;
	cursor: pointer;
	background-image:
		/* 中间渐变 */
		linear-gradient(180deg,
			rgba(255, 255, 255, 0.2) 15%,
			rgba(217, 37, 29, 1) 100%,
			rgba(255, 255, 255, 0.2) 20%),
		// /* 上方高光 */
		linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%),
		// /* 下方阴影 */
		linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%);
	background-blend-mode: normal, overlay, overlay;
	/* 添加外部阴影 */
	box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);

}
</style>
<style>
/* @media screen and (min-width:580px) {
	#app {
		max-width: 90% !important;
	}
} */
</style>


// WEBPACK FOOTER //
// src/pages/XVC/index.vue